/* eslint-disable no-unused-vars */
/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import { LinkingOptions } from '@react-navigation/native';
import * as Linking from 'expo-linking';

import { RootStackParamList } from '../types';

// eslint-disable-next-line no-shadow
export enum AppScreen {
  SIGN_IN = 'SignIn',
  HOME = 'Home',
  PROFILE = 'Profile',
  ANALYTICS = 'Analytics',
  NOTIFICATIONS = 'Notifications',
  MAP = 'Map',
  ENERGY = 'Energy',
  IT = 'IT',
  EXTERNAL_ENVIRONMENT = 'ExternalEnvironment',
  INTERNAL_ENVIRONMENT = 'InternalEnvironment',
  ERGONOMICS = 'Ergonomics',
  AMENITIES = 'Amenities',
  OCCUPANCY = 'BuildingOccupancy',
  SATISFACTION = 'OccupantSatisfaction',
  TICKETS = 'Tickets',
  TICKETS_V2 = 'TicketsV2',
  ASSET_MANAGEMENT = 'AssetManagement',
  TEMPLATE_MANAGEMENT = 'TemplateManagement',
  TEMPLATE_MANAGEMENTV2 = 'TemplateManagementV2',
  LOCATION_MANAGEMENT = 'LocationManagement',
  USER_MANAGEMENT = 'UserManagement',
  USER_MANAGEMENT_V2 = 'UserManagementV2',
  NOTIFICATIONS_LOG = 'NotificationsLog',
  KNOWLEDGE_CENTER = 'KnowledgeCenter',
  HAPPY_CHAT = 'HappyChat',
  HAPPY_CHAT_V2 = 'HappyChatV2',
  SUPPORT = 'Support',
  WIDGET_SHOWCASE = 'WidgetShowcase',
  GRAPH_PROTOTYPE = 'GraphPrototype',
  TEST_WEB_VIEW = 'TestWebView',
  SMART_GUARD = 'SmartGuard',
  PDFViewer = 'PDFViewer',
}

const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [Linking.createURL('/')],
  config: {
    screens: {
      Root: {
        screens: {
          [AppScreen.SIGN_IN]: {
            screens: {
              [AppScreen.SIGN_IN]: AppScreen.SIGN_IN,
            },
          },
          [AppScreen.HOME]: {
            screens: {
              HomeScreen: AppScreen.HOME,
            },
          },
          [AppScreen.PROFILE]: {
            screens: {
              ProfileScreen: AppScreen.PROFILE,
            },
          },
          [AppScreen.NOTIFICATIONS]: {
            screens: {
              NotificationsScreen: AppScreen.NOTIFICATIONS,
            },
          },
          [AppScreen.ANALYTICS]: {
            path: AppScreen.ANALYTICS,
            screens: {
              AnalyticsScreen: AppScreen.ANALYTICS,
            },
          },
          OccupantSatisfaction: {
            path: AppScreen.SATISFACTION,
            screens: {
              AnalyticsScreen: 'Satisfaction',
            },
          },
          HappyScoreAnalytics: {
            path: 'HAPPY SCORE ANALYTICS',
            screens: {
              HomeScreen: 'HAPPY SCORE ANALYTICS',
            },
          },
          BuildingOccupancy: {
            path: 'BuildingOccupancy',
            screens: {
              OccupantsScreen: 'Occupancy',
            },
          },
          [AppScreen.WIDGET_SHOWCASE]: {
            path: AppScreen.WIDGET_SHOWCASE,
            screens: {
              WidgetShowcaseScreen: AppScreen.WIDGET_SHOWCASE,
            },
          },
          [AppScreen.GRAPH_PROTOTYPE]: {
            path: AppScreen.GRAPH_PROTOTYPE,
            screens: {
              GraphPrototype: AppScreen.GRAPH_PROTOTYPE,
            },
          },
          [AppScreen.TEST_WEB_VIEW]: {
            path: AppScreen.TEST_WEB_VIEW,
            screens: {
              TestWebView: AppScreen.TEST_WEB_VIEW,
            },
          },
          [AppScreen.PDFViewer]: {
            path: AppScreen.PDFViewer,
            screens: {
              PDFViewer: AppScreen.PDFViewer,
            },
          },
          [AppScreen.AMENITIES]: {
            path: AppScreen.AMENITIES,
            screens: {
              [AppScreen.AMENITIES]: AppScreen.AMENITIES,
            },
          },
          [AppScreen.ERGONOMICS]: {
            path: AppScreen.ERGONOMICS,
            screens: {
              [AppScreen.ERGONOMICS]: AppScreen.ERGONOMICS,
            },
          },
          [AppScreen.MAP]: {
            path: AppScreen.MAP,
            screens: {
              [AppScreen.MAP]: AppScreen.MAP,
            },
          },
          [AppScreen.ENERGY]: {
            path: AppScreen.ENERGY,
            screens: {
              [AppScreen.ENERGY]: AppScreen.ENERGY,
            },
          },
          [AppScreen.IT]: {
            path: AppScreen.IT,
            screens: {
              [AppScreen.IT]: AppScreen.IT,
            },
          },
          [AppScreen.EXTERNAL_ENVIRONMENT]: {
            path: AppScreen.EXTERNAL_ENVIRONMENT,
            screens: {
              [AppScreen.EXTERNAL_ENVIRONMENT]: AppScreen.EXTERNAL_ENVIRONMENT,
            },
          },
          [AppScreen.INTERNAL_ENVIRONMENT]: {
            path: AppScreen.INTERNAL_ENVIRONMENT,
            screens: {
              [AppScreen.INTERNAL_ENVIRONMENT]: AppScreen.INTERNAL_ENVIRONMENT,
            },
          },
          [AppScreen.TICKETS]: {
            path: AppScreen.TICKETS,
            screens: {
              [AppScreen.TICKETS]: AppScreen.TICKETS,
            },
          },
          [AppScreen.TICKETS_V2]: {
            path: AppScreen.TICKETS_V2,
            screens: {
              [AppScreen.TICKETS_V2]: AppScreen.TICKETS_V2,
            },
          },
          [AppScreen.ASSET_MANAGEMENT]: {
            path: AppScreen.ASSET_MANAGEMENT,
            screens: {
              [AppScreen.ASSET_MANAGEMENT]: AppScreen.ASSET_MANAGEMENT,
            },
          },
          [AppScreen.TEMPLATE_MANAGEMENTV2]: {
            path: AppScreen.TEMPLATE_MANAGEMENTV2,
            screens: {
              [AppScreen.TEMPLATE_MANAGEMENTV2]: AppScreen.TEMPLATE_MANAGEMENTV2,
            },
          },
          [AppScreen.LOCATION_MANAGEMENT]: {
            path: AppScreen.LOCATION_MANAGEMENT,
            screens: {
              [AppScreen.LOCATION_MANAGEMENT]: AppScreen.LOCATION_MANAGEMENT,
            },
          },
          [AppScreen.NOTIFICATIONS_LOG]: {
            path: AppScreen.NOTIFICATIONS_LOG,
            screens: {
              [AppScreen.NOTIFICATIONS_LOG]: AppScreen.NOTIFICATIONS_LOG,
            },
          },
          [AppScreen.USER_MANAGEMENT]: {
            path: AppScreen.USER_MANAGEMENT,
            screens: {
              [AppScreen.USER_MANAGEMENT]: AppScreen.USER_MANAGEMENT,
            },
          },
          [AppScreen.USER_MANAGEMENT_V2]: {
            path: AppScreen.USER_MANAGEMENT_V2,
            screens: {
              [AppScreen.USER_MANAGEMENT_V2]: AppScreen.USER_MANAGEMENT_V2,
            },
          },
          [AppScreen.KNOWLEDGE_CENTER]: {
            path: AppScreen.KNOWLEDGE_CENTER,
            screens: {
              [AppScreen.KNOWLEDGE_CENTER]: AppScreen.KNOWLEDGE_CENTER,
            },
          },
          [AppScreen.HAPPY_CHAT]: {
            path: AppScreen.HAPPY_CHAT,
            screens: {
              [AppScreen.HAPPY_CHAT]: AppScreen.HAPPY_CHAT,
            },
          },
          [AppScreen.HAPPY_CHAT_V2]: {
            path: AppScreen.HAPPY_CHAT_V2,
            screens: {
              [AppScreen.HAPPY_CHAT_V2]: AppScreen.HAPPY_CHAT_V2,
            },
          },
          [AppScreen.SUPPORT]: {
            path: AppScreen.SUPPORT,
            screens: {
              [AppScreen.SUPPORT]: AppScreen.SUPPORT,
            },
          },
        },
      },
      Modal: 'modal',
      Home: '*',
      Dashboard: 'Dashboard',
    },
  },
};

export default linking;
